import * as $ from 'jquery';
import {userInfo} from "./UserInfo";
import getUserInfo from "modules/utilities/getUserInfo";
declare const CRUserInfo: any;

import {Layout} from 'modules/shared/constants/index.ts';
type LayoutType = "Mobile" | "Desktop" | "Tablet";

export class PageInfo {
    domain:string;
    siteCatalystPageProperties:any;
    trackOnLoad:boolean;
    alternateProperties:any;
    data:any;
    public mobileWidthLimitPx: number = 767;
    public tabletWidthLimitPx: number = 1199;

    constructor(siteCatalystPageProperties?:any,
                triggerPageLoad?:boolean,
                alternateProperties?:any, data?:any) {
        this.siteCatalystPageProperties = siteCatalystPageProperties;
        this.trackOnLoad = triggerPageLoad;
        this.alternateProperties = alternateProperties;
        this.data = data;
    }

    getLayout():LayoutType {
        let widthScreen = $(window).width();
        let layout = Layout.MOBILE;
        if (widthScreen > this.tabletWidthLimitPx) {
            layout = Layout.DESKTOP;
        } else if (widthScreen > this.mobileWidthLimitPx) {
            layout = Layout.TABLET;
        }

        return <LayoutType>layout;
    }

    isMobileLayout() {
        return this.getLayout() == Layout.MOBILE;
    }

    isTabletLayout() {
        return this.getLayout() == Layout.TABLET;
    }

    isDesktopLayout() {
        return this.getLayout() == Layout.DESKTOP;
    }

    detectSize() {
        let widthScreen = $(window).width();
        let layout = "xs";
        if (widthScreen > 1199) {
            layout = 'lg';
        } else if (widthScreen > 767) {
            layout = 'md';
        }

        return layout;
    }

    subscribe() {
        $(".sign-in").show();
        $('.sign-in-input').first().find('input').focus();
        $(".sign-in-dialog").show();
        window.scrollTo(0, 0);
        return false;
    }

    getUserId() {
        return userInfo.getUserId();
    }

    getMobileWidthLimitPX() {
        return this.mobileWidthLimitPx;
    }

    getTabletWidthLimitPX() {
        return this.tabletWidthLimitPx;
    }

    showLogoutButton() {
        var buttons = $('.footer-mobile-account-btn');
        if (CRUserInfo.hasData() && CRUserInfo.getName()) {
            buttons.find('.global-footer-subscribe-btn').hide().end()
                .find('.global-footer-account-btn').hide().end()
                .find('.global-footer-account-btn.logOut').show();
        }
    }

    hideSubscribeButton() {
        if (CRUserInfo && CRUserInfo.hasAtLeastMembershipTier('EMAIL')) {
            $('.subscribe-footer-btn, .subscribe-footer-btn + br').hide();
        }
    }


    showHideLogoutInFooter() {

        getUserInfo().then(() => {
            this.showLogoutButton();
            this.hideSubscribeButton();
        });
    }

}

let pageInfo = new PageInfo();
export {pageInfo}



// WEBPACK FOOTER //
// ./resources/modules/models/PageInfo.ts